import {
  GET_WEB_HOOKS_PROCESS_LIST_SUCCESS,
  GET_WEB_HOOKS_PROCESS_LIST,
  GET_WEB_HOOKS_SUCCESS,
  GET_WEB_HOOKS,
  POST_WEB_HOOKS_INSERT_SUCCESS,
  POST_WEB_HOOKS_INSERT_ERROR,
  POST_WEB_HOOKS_INSERT,
  POST_WEB_HOOKS_UPDATE,
  POST_WEB_HOOKS_UPDATE_SUCCESS,
  POST_WEB_HOOKS_UPDATE_ERROR,
  PUT_WEB_HOOKS_DELETE,
  PUT_WEB_HOOKS_DELETE_SUCCESS,
  PUT_WEB_HOOKS_DELETE_ERROR,
} from "./actionType"

const initialState = {
  webHooksinsertSuccessList: {},
  webHooksupdateSuccessList: {},
  webHooksdeleteSuccessList: {},
}
const webHooksReducer = (state = initialState, action) => {
  switch (action.type) {

    // get process dopdown api for webhook
    case GET_WEB_HOOKS_PROCESS_LIST:
      state = {
        ...state,
        getwebhookProcessList: action?.payload,
      }
      break
    case GET_WEB_HOOKS_PROCESS_LIST_SUCCESS:
      state = {
        ...state,
        webHooksprocessSuccessList: action.payload,
        webHooksprocessError: null,
      }
      break
    // get data api for webhook
    case GET_WEB_HOOKS:
      state = {
        ...state,
        getwebhook: action?.payload,
      }
      break
    case GET_WEB_HOOKS_SUCCESS:
      state = {
        ...state,
        webHooksSuccessList: action.payload,
        webHooksError: null,
      }
      break
    // post insert api for webhook
    case POST_WEB_HOOKS_INSERT:
      state = {
        ...state,
        postwebhookinsert: action?.payload,
      }
      break
    case POST_WEB_HOOKS_INSERT_SUCCESS:
      state = {
        ...state,
        webHooksinsertSuccessList: action.payload,
        webHooksinsertError: null,
      }
      break
    case POST_WEB_HOOKS_INSERT_ERROR:
      state = {
        ...state,
        webHooksinsertErrorList: action.payload,
        webHooksinsertError: null,
      }
      break
    // post update api for webhook
    case POST_WEB_HOOKS_UPDATE:
      state = {
        ...state,
        postwebhookupdate: action?.payload,
      }
      break
    case POST_WEB_HOOKS_UPDATE_SUCCESS:
      state = {
        ...state,
        webHooksupdateSuccessList: action.payload,
        webHooksupdateError: null,
      }
      break
    case POST_WEB_HOOKS_UPDATE_ERROR:
      state = {
        ...state,
        webHooksupdateErrorList: action.payload,
        webHooksupdateError: null,
      }
      break
    // put delete api for webhook
    case PUT_WEB_HOOKS_DELETE:
      state = {
        ...state,
        putwebhookdelete: action?.payload,
      }
      break
    case PUT_WEB_HOOKS_DELETE_SUCCESS:
      state = {
        ...state,
        webHooksdeleteSuccessList: action.payload,
        webHooksdeleteError: null,
      }
      break
    case PUT_WEB_HOOKS_DELETE_ERROR:
      state = {
        ...state,
        webHooksdeleteErrorList: action.payload,
        webHooksdeleteError: null,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default webHooksReducer
